import React from 'react'
import { Grid } from '@mui/material'
import { ItemsSelect } from 'components/forms/components/Select/custom'


export default function CursoExtranjeroTemplate({ register, errors, reset }) {

    return (
        <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }} mt={4}>

            <Grid item xs={2}>
                <ItemsSelect label={'Año'} name={"ano"} keyValue={"curso_escolar"} register={register} errors={errors} wantToReset={reset} />
            </Grid>

            <Grid item xs={3} border={'1px solid red'}>
                tipo curso
            </Grid>

        </Grid>
    )
}
